module.exports = __webpack_public_path__ + "static/media/videoPlayIcon.2c9fe3f7.png";